export const GLOBAL_STATE = 'GeneralAdmission'

export const GENERAL_APPLICATION = 'application'
export const GENERAL_APPLICATIONS = 'applications'
export const GENERAL_APPLICATION_LIST = 'applicationList'
export const GENERAL_APPLICATION_ALL = 'applicationAll'
export const GENERAL_APPLICATION_STATUS = 'applicationStatus'
export const GENERAL_APPLICATION_TYPES = 'applicationTypes'

export const GENERAL_APPLICATION_FIELD_BATCH = 'applicationFieldBatch'

// category
export const GENERAL_APPLICATION_CATEGORY = 'category'
export const GENERAL_APPLICATION_CATEGORY_LIST = 'categoryList'
export const GENERAL_APPLICATION_CATEGORY_ALL = 'categoryAll'

// request
export const GENERAL_APPLICATION_REQUEST_ALL = 'requestAll'
export const GENERAL_APPLICATION_REQUEST_EDIT = 'requestEdit'
export const GENERAL_APPLICATION_REQUEST_UPDATE = 'requestUpdate'
